import { Outlet } from "react-router-dom";

export function CenteredLayout() {
	return (
		<div className="w-full min-h-screen flex flex-col justify-center items-center">
			<Outlet />
		</div>
	);
}
